/**
 * Enum of calendar ids. Unknown should never occur.
 */
export enum Role {
  ProgramAdmin = 1,
  TestAdmin = 2
}
